"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackLinkClick = exports.trackCallbackBannerShow = exports.trackCallback = exports.trackBannerShow = void 0;
var _analytics = require("@cian/analytics");
const trackLinkClick = () => {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'newbuilding_banner',
    action: 'click_sopr',
    label: 'reorientation_rent'
  });
};
exports.trackLinkClick = trackLinkClick;
const trackBannerShow = () => {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'newbuilding_banner',
    action: 'show_sopr',
    label: 'reorientation_rent'
  });
};
exports.trackBannerShow = trackBannerShow;
const trackCallbackBannerShow = () => {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'newbuilding_banner',
    action: 'show_sopr',
    label: 'reorientation_rent_oz'
  });
};
exports.trackCallbackBannerShow = trackCallbackBannerShow;
const trackCallback = _ref => {
  let {
    pageType,
    gaLabel,
    userId,
    phone
  } = _ref;
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: pageType,
    action: 'CallBack_send_nb_reorientation_rent',
    label: gaLabel,
    user: {
      userId,
      extra: {
        phone
      }
    }
  });
};
exports.trackCallback = trackCallback;